import { gameItemInfo } from './gameCatalog';
import { blockLabel } from './blockLabel';

const items: Record<string, [string, string?]> = {
  redstone_wire: ['レッドストーン', '「レッドストーンダスト」を えらぼう'],
  tripwire: ['糸'], wall_torch: ['たいまつ'], torch: ['たいまつ'],
  redstone_wall_torch: ['レッドストーン'], soul_wall_torch: ['魂のたいまつ'],
  water: ['水入りバケツ'], lava: ['溶岩入りバケツ'],
  oak_door: ['ドア', '「木のドア」または「オークのドア」を えらぼう'],
  oak_planks: ['オーク', '「オークの木材」または「オークの板材」を えらぼう'],
};
const unavailable = new Set(['air', 'cave_air', 'void_air', 'piston_head', 'sticky_piston_head', 'moving_piston', 'nether_portal', 'end_portal', 'farmland']);
const commands = new Set(['command_block', 'repeating_command_block', 'chain_command_block', 'structure_block', 'structure_void', 'barrier', 'light', 'jigsaw']);

/** Search is stable across inventory layout changes; avoid promising a fixed slot/category. */
export function inventoryHint(rawName: string): { query: string | null; note: string } {
  if (rawName.includes(':') && !rawName.startsWith('minecraft:')) {
    return { query: null, note: '追加コンテンツの ブロックです。先生に たしかめよう。' };
  }
  const name = rawName.replace(/^minecraft:/, '');
  if (unavailable.has(name)) return { query: null, note: 'そのままでは さがせない ブロックです。置き方を 先生に きこう。' };
  if (commands.has(name)) return { query: null, note: 'ふつうの 一覧には ありません。先生に 出してもらおう。' };
  const official = gameItemInfo(name);
  if (official?.name && official.category) return { query: official.name, note: `${official.category}${official.group ? ' → '+official.group : ''} に あります` };
  const item = items[name];
  const label = blockLabel(name);
  if (!item && label === name) return { query: null, note: 'さがす名前が まだ分かりません。先生に ID を みせよう。' };
  const searchName = /_(planks|stairs|slab|wool|carpet)$/.test(name) && label.includes('の') ? label.split('の')[0].replace(/色$/, '') : label;
  return { query: item?.[0] ?? searchName, note: item?.[1] ?? 'クリエイティブの 虫めがね（検索）で さがそう' };
}
